module.exports = __webpack_public_path__ + "img/icon63.43531dc1.png";